<template>
  <div>
    <base-header class="mt-4 pb-6" type=""></base-header>
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>{{language_terms['RECEIPT_ENTRIES']}}</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col lg="3" md="6">
                  <base-input :label="language_terms['CUSTOMER'] + ' From'">
                    <multiselect
                        :internalSearch = "false"
                        v-model="filter.customer_from"
                        ref="multiselcetRef"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :preserve-search="false"
                        :options="customers"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindCustomer"
                    >
                    </multiselect>
                  </base-input>
                </b-col>
                <b-col lg="3" md="6">
                  <base-input :label="language_terms['CUSTOMER'] + ' To'">
                    <multiselect
                        :internalSearch = "false"
                        v-model="filter.customer_to"
                        ref="multiselcetRef"
                        label="name"
                        track-by="id"
                        placeholder="Type to search"
                        open-direction="bottom"
                        :preserve-search="false"
                        :options="customers"
                        :multiple="false"
                        :searchable="true"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit="50"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="false"
                        :hide-selected="false"
                        @search-change="asyncFindCustomer"
                    >
                    </multiselect>
                  </base-input>
                </b-col>
                <b-col lg="2" md="6">
                  <base-input :label="language_terms['DATE_FROM']">
                    <flat-picker slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white;"
                                class="form-control datepicker"
                                v-model="filter.date_from">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col lg="2" md="6">
                  <base-input :label="language_terms['DATE_TO']">
                    <flat-picker slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white;"
                                class="form-control datepicker"
                                v-model="filter.date_to">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col lg="1" class="mt-4">
                  <base-button type="primary" @click="onClickSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                </b-col>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>

      <b-row v-if="tableItems.length > 0">
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>Sales Receipt</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt--4" v-if="tableItems.length > 0" >
                <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['DATE']}}</b-th>
                            <b-th>{{language_terms['CODE']}}</b-th>
                            <b-th>{{language_terms['CUSTOMER_NAME']}} </b-th>
                            <b-th>{{language_terms['CURRENCY']}} </b-th>
                            <b-th>{{language_terms['AMOUNT']}} </b-th>
                            <b-th>{{language_terms['IN_HOME_AMOUNT']}} </b-th>
                            <b-th></b-th>
                        </b-thead>
                        <b-tbody>
                            <tr v-for="(receipt, i) in tableItems" :key="i" @click="onClickReceipt(receipt)">
                                <td>{{receipt.date}}</td>
                                <td>{{receipt.code}}</td>
                                <td>{{receipt.customer_name}}</td>
                                <td>{{receipt.currency_code}}</td>
                                <td>{{receipt.amount}}</td>
                                <td>{{receipt.amount_home}}</td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
            </b-row>                            
            </card>
          </div>
        </b-col>
      </b-row>
      
      <b-modal id="rowDetailsModal" v-model="rowDetailsModal" size="xl" centered class="my-modal" hide-footer>
        <template>
          <div>
            <b-row class="align-items-center">
              <b-col md="11" fluid class="mt--5">
                <h6 class="h2">{{language_terms["RECEIPT_DETAILS"]}}</h6>
              </b-col>
              <b-col md="1" fluid class="mt--5 mb-2">
                <base-button type="success" @click="onClickPrintReceipt" class="mt-2"><i class="fa fa-print"></i></base-button>
              </b-col>
            </b-row>
            <b-row >
              <b-col cols="12">
                <v-client-table v-model="report.rows" :columns="report.columns" :options="reportOptions"></v-client-table>
              </b-col>
            </b-row>
          </div>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import moment from 'moment'
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
  },
  async mounted()
  {
    this.loadingCounter++
    if(this.id == '_new')
    {
      
    }
    else
    {
        //await this.retrieve(this.id)
    }
    this.loadingCounter--      
  },

  data(){
    return{
      receipt_code:null,
      loadingCounter:0,
      customers:[],
      selectedReceipt:[],
      reportOptions:{perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C', hiddenColumns:[],filterable:false},
      report:{headers:[], rows:[]},
      rowDetailsModal:false,
      fullPage:true,
      filter:{
        customer_from: null,
        customer_to:null,
        date_from:new Date(),
        date_to:new Date(),
      },
      tableItems:[],
      tableColumns: ["doc.date","type", "document #", "currency", "org.amount", "exchange rate", "in home amount"],
    }
  },

  methods:{
    limitText(count)
    {
        return `and ${count} others`;
    },
    async asyncFindCustomer(query) 
    {
      let payload = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) {
            this.customers = response.data.data;
          }
        })
        .catch((error) => {
          if (error.response) {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});          
        }
        });
    },
    async onClickPrintReceipt()
    {
      let url = 'https://reports.unityerp.com/esteam/sales-receipt/' + encodeURIComponent(localStorage.access_token)
        + '/' + encodeURIComponent(this.receipt_code)
      window.open(url , '_blank');
    },
    async onClickPrint()
    {
      this.loadingCounter++

      let payload = {document_id:this.selectedInvoice.document_id}
      await axios
      .post(apiRoutes["SIP_PRINT"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          let url =  'https://reports.unityerp.com/esteam/sales-item-picking/' +  encodeURIComponent(localStorage.getItem('access_token')) + '/' + encodeURIComponent(this.selectedInvoice.code);
          window.open(url);            
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });

      this.loadingCounter--
    },

    async onClickReceipt(receipt)
    {
      if (receipt)
      {
        this.receipt_code = receipt.code
        let payload = {receipt_id:receipt.id}
        await axios.post(apiRoutes['CLIENT_SALES_RECEIPT_ENTRY_RETRIEVE'],payload, authHeader()).then((response)=>
        {
          if (response.data.code == 1)
          {
              this.report = response.data.data
              this.rowDetailsModal = true
          }
          else
          {
              this.report = null;
          }
        }
        )
        .catch((error)=> {
            if(error.response)
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
      }
    },

    async onClickRetrieve(bankaccount_code)
      {
          let payload = {code:bankaccount_code}
          await axios
          .post(apiRoutes["SIP_RETRIEVE"], payload, authHeader())
          .then((response) => 
          {
              if (response.data.code == 1) {
                  this.form = response.data.data
              } 
              else 
              {
                  alert('Failed');
              }

          })
          .catch((error) => {
              if (error.response) {
                  Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
              }
          });
      },

    async onClickSearch()
    {
      this.loadingCounter++

      this.filter.limit = ''
      let payload = this.filter
      if (payload.customer_from)
        payload.customer_from_name = payload.customer_from.name
      else
        payload.customer_from_name = null

      if (payload.customer_to)
        payload.customer_to_name = payload.customer_to.name
      else
        payload.customer_to_name = null
            
      await axios
      .post(apiRoutes["CLIENT_SALES_RECEIPT_ENTRIES_QUICK_SEARCH"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          this.tableItems = response.data.data
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });

      this.loadingCounter--
    },
    onClickReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          code_from:null,
          code_to:null,
      }
    },
  }
}
</script>
  